import { createContext } from 'react';
const TrackingContext = /*#__PURE__*/createContext({
  track: () => {}
});
export default TrackingContext;